<section class="landing-login">    
     <app-header-v1 [presentComponent]="presentComponent"></app-header-v1>

<div class="banner-sec">
        <div class="landing-container">
            <div class="grid">
                <div class="col-12 xl:col-6 lg:col-5">
                    <div class="banner-textbox">
                        <p class="banner-subheading">
                            Streamlined Short & Long-Term, Truck and Trailer Parking
                        </p>
                        <h1 class="banner-heading">
                            Pave the way,<br /> Park with ease
                        </h1>
                        <p class="banner-subheading2">
                            Begin Your Journey:
                        </p>
                        <div class="banner-btnbox">
                            <a class="banner-btn" (click)="openPopup()">
                                Book Truck Parking
                            </a>
                            <a routerLink="/parking-lot-manager" class="banner-btn-outline">
                                Parking Lot Managers
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>